import {useVueInternals} from '@malt/vue3-use';
import {onBeforeUnmount, onMounted, ref, Ref} from 'vue';

export function useHover(customRef?: Ref<HTMLElement>) {
    const {proxy} = useVueInternals();
    const isHovering = ref(false);

    const target = ref<HTMLElement>();

    onMounted(() => {
        target.value = customRef?.value ?? (proxy?.$el as HTMLElement);
        if (target.value) {
            target.value.addEventListener('mouseenter', handleMouseEnter);
            target.value.addEventListener('mouseleave', handleMouseLeave);
        }
    });

    onBeforeUnmount(() => {
        if (target.value) {
            target.value.removeEventListener('mouseenter', handleMouseEnter);
            target.value.removeEventListener('mouseleave', handleMouseLeave);
        }
    });

    function handleMouseEnter() {
        isHovering.value = true;
    }
    function handleMouseLeave() {
        isHovering.value = false;
    }

    return {
        isHovering,
    };
}
